$component-class: 'popup-banner-type-2';

// Layout is written out here instead of delegating to me-section/me-row/me-column.
// The old tree was me-section > me-container > me-row > me-column > __actions — eight
// DOM nodes for one right-aligned strip — and every gap prop was `none`, so the grid
// contributed nothing but still made the 33 KB layout class matrix a critical-CSS
// dependency of a block that sits above the fold.
// Mapping from the primitives that used to render this, so the geometry is traceable:
//   me-section  → .#{$component-class}          width: 100%
//   me-container→ .#{$component-class}__container  margin/padding-inline/max-width
//                 (y-gap-2xs / y-gap-lg-2xs are both var(--spacing-2xs))
//   me-row      → .#{$component-class}__row      flex + justify from the `align` prop
//   me-column   → folded into __actions          span="auto" == flex: 0 0 auto; width: auto
.#{$component-class} {
  display: none;
  width: 100%;
  background-color: var(--background-color-secondary);

  // Doubled on purpose — this reproduces existing production geometry, it is not a
  // design value. me-section copied the host's class onto the inner <section>, so
  // `<me-section class="popup-banner-type-2">` put this class on two nested elements and
  // `padding: var(--radius-size-sm) 0` applied twice: the strip renders 40.64px tall, not
  // 32.64px. Collapsing to one element removes that duplication, so the refactor would
  // silently shorten the banner by 8px and lift every section below it. Keeping the
  // measured value here holds the refactor to zero visual change.
  // To drop the extra 4px, change this to `var(--radius-size-sm)` as a separate,
  // reviewable visual fix.
  padding: calc(var(--radius-size-sm) * 2) 0;

  @include desktop {
    display: block;
  }

  &__container {
    margin-inline: auto;
    padding-block: var(--spacing-2xs);
    padding-inline: var(--spacing-md);

    // Theme-aware page width: the SignNow theme narrows containers to 1312px. Declared
    // as a custom property so this does not hardcode a product value the way the
    // `$sn-container-max-width` copies scattered across the repo do.
    max-width: var(--me-container-max-width, #{$media-desktop});
  }

  &__row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-end;
  }

  &--align-start &__row {
    justify-content: flex-start;
  }

  &--align-center &__row {
    justify-content: center;
  }

  &--align-end &__row {
    justify-content: flex-end;
  }

  &__actions {
    flex: 0 0 auto;
    width: auto;
    display: flex;
    align-items: center;
    gap: var(--spacing-2xl);
  }

  .me-button {
    color: var(--action-color-primary);
    padding: 0;
  }
}
